// The sha256 of a dropped file, hashed in the browser (paperwork-1 A18, R5): the drop's preview asks the server whether these
// bytes are NDEMNIFLY's own paper before it offers a carrier kind, without uploading them twice. null when the browser cannot
// hash (no SubtleCrypto outside a secure context); the server still refuses our own paper at filing (fileDocument), so a
// missing hash only means the dialog cannot hide the carrier kinds in advance.
export async function sha256OfFile(file) {
  try {
    if (!file || typeof file.arrayBuffer !== 'function' || !globalThis.crypto?.subtle) return null;
    const digest = await globalThis.crypto.subtle.digest('SHA-256', await file.arrayBuffer());
    return [...new Uint8Array(digest)].map((b) => b.toString(16).padStart(2, '0')).join('');
  } catch {
    return null;
  }
}
